export const getImageDataByHandle = (data, handle) => {
    for (let i = 0; i < data.edges.length; ++i) {
        if (data.edges[i].node.handle === handle) {
            return data.edges[i].node.gatsbyImageData;
        }
    }
}
